/* GNT custom cart drawer (replaces Corner Cart). Vanilla JS, no dependencies.
 * Opens on: #CartButton click, [data-cart-drawer-trigger] click, 'cart:item-added',
 * 'shapes:modalcart:afteradditem'. Re-renders on 'cart:refresh'.
 * Dispatches 'cart:updated' after its own changes so gnt-welcome-kit-card.js can reconcile gifts.
 */
(function () {
  'use strict';
  // Note: not window.GntCart, the #GntCart element already claims that name on window.
  if (window.GntCartDrawer) return;

  var root = document.getElementById('GntCart');
  var cfgEl = document.getElementById('GntCartConfig');
  if (!root || !cfgEl) return;
  var CFG = JSON.parse(cfgEl.textContent);

  // Bypass the welcome-kit fetch patch for our own calls so it never attaches a selling plan
  // to recommendation / upgrade adds. We dispatch cart:updated ourselves so it still reconciles gifts.
  // Captured before we wrap window.fetch below. Pages without the welcome-kit card (e.g. Face Tape)
  // have no __gnt_original_fetch, and window.fetch would be our own wrapper, which redraws on every add.
  var nativeFetch = window.fetch;
  var rawFetch = function () { return (window.__gnt_original_fetch || nativeFetch).apply(window, arguments); };

  var $ = function (sel) { return root.querySelector(sel); };
  var els = {
    panel: $('.gnt-cart__panel'),
    count: $('[data-gnt-cart-count]'),
    strip: $('[data-gnt-cart-strip]'),
    stripText: $('[data-gnt-cart-strip-text]'),
    progress: $('[data-gnt-cart-progress]'),
    progressFill: $('[data-gnt-cart-progress-fill]'),
    items: $('[data-gnt-cart-items]'),
    upgrade: $('[data-gnt-cart-upgrade]'),
    recs: $('[data-gnt-cart-recs]'),
    recsTrack: $('[data-gnt-cart-recs-track]'),
    empty: $('[data-gnt-cart-empty]'),
    footer: $('[data-gnt-cart-footer]'),
    protect: $('[data-gnt-cart-protect]'),
    protectInput: $('[data-gnt-cart-protect-input]'),
    protectPrice: $('[data-gnt-cart-protect-price]'),
    subtotal: $('[data-gnt-sum-subtotal]'),
    discountRow: $('[data-gnt-sum-discount-row]'),
    discount: $('[data-gnt-sum-discount]'),
    shipping: $('[data-gnt-sum-shipping]'),
    total: $('[data-gnt-sum-total]'),
    saveRow: $('[data-gnt-sum-save-row]'),
    save: $('[data-gnt-sum-save]'),
    loading: $('[data-gnt-cart-loading]'),
    sumwrap: $('[data-gnt-cart-sumwrap]')
  };

  var state = { cart: null, busy: false, lastFocus: null, giftSyncing: false };
  var productCache = {};
  var recsKey = '';

  // ---------- helpers ----------
  var money = function (cents) {
    var v = (cents || 0) / 100;
    return '$' + (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2));
  };
  var esc = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };
  var img = function (url, w) {
    if (!url) return '';
    if (url.indexOf('//') === 0) url = 'https:' + url;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 200);
  };
  var hasProp = function (item, key) { return item.properties && item.properties[key]; };
  var isProtection = function (item) { return item.variant_id === CFG.protectionVariantId; };
  var isSub = function (item) { return !!item.selling_plan_allocation; };
  var isGift = function (item) {
    return item.final_line_price === 0 && item.original_line_price > 0 &&
      (CFG.giftProductIds.indexOf(item.product_id) > -1 || hasProp(item, '_wk_gift') || hasProp(item, '_gnt_gift'));
  };
  var isPaid = function (item) { return item.final_line_price > 0 && !isProtection(item); };
  var monthsOf = function (title) { var m = /(\d+)\s*month/i.exec(title || ''); return m ? parseInt(m[1], 10) : null; };

  function fetchJSON(url, opts) {
    return rawFetch(url, Object.assign({ credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' } }, opts || {}))
      .then(function (r) { if (!r.ok) throw r; return r.json(); });
  }
  var recsCache = {};
  function getRecs(productId) {
    if (!recsCache[productId]) {
      recsCache[productId] = rawFetch('/recommendations/products.json?product_id=' + productId + '&limit=10&intent=related', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .catch(function () { delete recsCache[productId]; return { products: [] }; });
    }
    return recsCache[productId];
  }
  var productData = {}; // resolved product JSON by handle, for instant previews

  // Instant Add to Cart: show the product the moment the button is tapped, built from what the
  // page has selected (pack, sub or one-off, price). Shopify's real cart replaces it ~1s later.
  function previewAdd(btn) {
    var form = btn.closest('form[action*="/cart/add"]');
    var handle = form && form.getAttribute('data-product-handle');
    if (!handle) { var m = /^\/products\/([^/?#]+)/.exec(location.pathname); handle = m && m[1]; }
    var p = handle && productData[handle];
    var idEl = form && form.querySelector('[name="id"]');
    if (!p || !idEl || !state.cart) return false;
    var v = p.variants.filter(function (x) { return String(x.id) === String(idEl.value); })[0];
    if (!v) return false;
    var section = form.closest('[id^="shopify-section"]') || document;
    var modeEl = section.querySelector('input[name="gnt-wk-mode"]:checked');
    var alloc = modeEl && modeEl.value === 'subscribe' ? (v.selling_plan_allocations || [])[0] : null;
    var planName = '';
    if (alloc) (p.selling_plan_groups || []).forEach(function (g) { g.selling_plans.forEach(function (s) { if (s.id === alloc.selling_plan_id) planName = s.name; }); });
    var unit = alloc ? alloc.price : v.price;
    var was = alloc ? (alloc.compare_at_price || v.price) : v.price;
    var img = (v.featured_image && v.featured_image.src) || p.featured_image || '';
    var line = {
      key: 'gnt-add-preview', product_id: p.id, variant_id: v.id, handle: p.handle, url: p.url || ('/products/' + p.handle),
      product_title: p.title, variant_title: v.title, image: img, quantity: 1, requires_shipping: true,
      final_price: unit, final_line_price: unit, original_price: was, original_line_price: was,
      selling_plan_allocation: alloc ? { compare_at_price: was, selling_plan: { id: alloc.selling_plan_id, name: planName } } : null
    };
    var lines = state.cart.items.slice();
    var same = lines.filter(function (l) { return l.variant_id === v.id && !!l.selling_plan_allocation === !!alloc && !isGift(l); })[0];
    if (same) lines = lines.map(function (l) { return l === same ? Object.assign({}, l, { quantity: l.quantity + 1, final_line_price: l.final_line_price + unit, original_line_price: l.original_line_price + was }) : l; });
    else lines.unshift(line);
    render(withLines(state.cart, withPreviewGifts(lines)));
    setPending(false);
    return true;
  }

  // The free extras the real cart will end up with, drawn straight away so the customer never
  // waits on Shopify to see them: tracker + protection with any paid item, Storage Container
  // with a welcome-kit sub, Tongue Cleaner with a 3/6-month one. Mirrors orphanKeys().
  function giftPreviewLine(handle, variantId, props) {
    var p = productData[handle];
    var v = p && p.variants.filter(function (x) { return x.id === variantId; })[0];
    if (!v) return null;
    return {
      key: 'gnt-gift-preview-' + variantId, product_id: p.id, variant_id: v.id, handle: p.handle, url: '/products/' + p.handle,
      product_title: p.title, variant_title: v.title, image: (v.featured_image && v.featured_image.src) || p.featured_image || '',
      quantity: 1, requires_shipping: true, properties: props,
      final_price: 0, final_line_price: 0, original_price: v.price, original_line_price: v.price, selling_plan_allocation: null
    };
  }
  function withPreviewGifts(lines) {
    var has = function (test) { return lines.some(test); };
    var paid = has(function (i) { return i.final_line_price > 0 && !isProtection(i) && !isGiftLine(i); });
    if (!paid) return lines;
    var subs = lines.filter(function (i) { return isSub(i) && CFG.welcomeKitProductIds.indexOf(i.product_id) > -1; });
    var extra = [];
    var push = function (l) { if (l) extra.push(l); };
    if (subs.length && !has(function (i) { return CFG.maxOneVariantIds.indexOf(i.variant_id) > -1; }))
      push(giftPreviewLine(CFG.giftHandles[1], CFG.maxOneVariantIds[0], { _wk_gift: 'yes' }));
    if (subs.some(function (i) { return monthsOf(i.variant_title) >= 3; }) && !has(function (i) { return i.product_id === CFG.tongueCleanerProductId; }))
      push(giftPreviewLine(CFG.giftHandles[2], CFG.tongueCleanerVariantId, { _wk_gift: 'yes' }));
    if (!giftOff(CFG.trackerProductId) && !has(function (i) { return i.product_id === CFG.trackerProductId; }))
      push(giftPreviewLine(CFG.giftHandles[0], CFG.trackerVariantId, { _gnt_gift: 'tracker' }));
    if (!protectOptedOut() && !has(isProtection))
      extra.push({ key: 'gnt-protect-preview', variant_id: CFG.protectionVariantId, product_id: 0, quantity: 1,
        final_line_price: 299, original_line_price: 299, final_price: 299, original_price: 299, requires_shipping: false });
    return lines.concat(extra);
  }

  function getProduct(handle) {
    if (!handle) return Promise.resolve(null);
    if (!productCache[handle]) {
      productCache[handle] = rawFetch('/products/' + handle + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) { if (p) productData[handle] = p; return p; })
        .catch(function () { return null; });
    }
    return productCache[handle];
  }

  // ---------- open / close ----------
  function open() {
    if (root.classList.contains('is-open')) return refresh();
    if (!state.loaded) setPending(true);
    state.lastFocus = document.activeElement;
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('gnt-cart-lock');
    setTimeout(function () { els.panel.focus({ preventScroll: true }); }, 50);
    return refresh();
  }
  function close() {
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('gnt-cart-lock');
    if (state.lastFocus && state.lastFocus.focus) state.lastFocus.focus({ preventScroll: true });
  }

  // ---------- cart actions ----------
  // Pending = drawer opened on an Add to Cart tap before the add has finished. Shows a loader
  // instead of the (possibly empty) previous cart, and never the empty-cart message.
  var pendingTimer = null;
  function setPending(on) {
    root.classList.toggle('is-pending', on);
    clearTimeout(pendingTimer);
    if (on) pendingTimer = setTimeout(function () { addDone(); setPending(false); if (!state.upgrading) refresh(); }, 6000);
  }
  function openPending() {
    state.awaitingAdd = true;
    setPending(true);
    if (!root.classList.contains('is-open')) {
      state.lastFocus = document.activeElement;
      root.classList.add('is-open');
      root.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('gnt-cart-lock');
    }
  }

  // Busy overlay can never stick: it clears itself after 8s even if a request hangs.
  var busyTimer = null;
  function setBusy(b) {
    state.busy = b;
    els.loading.hidden = !b;
    clearTimeout(busyTimer);
    if (b) busyTimer = setTimeout(function () { setBusy(false); refresh(); }, 8000);
  }
  function afterChange() {
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: state.cart }));
    return refresh();
  }
  // /cart/change.js answers with the full cart, so draw from that instead of reading the cart again.
  // A background refresh then tidies the automatic extras (tracker / protection).
  // Free gifts that no longer qualify once something is removed (Kevin: "gifts go if the main item
  // goes"). Only gift-flagged / free lines; a gift product the customer actually paid for stays.
  function isGiftLine(i) {
    return hasProp(i, '_wk_gift') || hasProp(i, '_gnt_gift') ||
      (i.final_line_price === 0 && CFG.giftProductIds.indexOf(i.product_id) > -1);
  }
  function orphanKeys(cart) {
    var kit = CFG.welcomeKitProductIds;
    var subs = cart.items.filter(function (i) { return isSub(i) && kit.indexOf(i.product_id) > -1; });
    var cleanerSub = subs.some(function (i) { return monthsOf(i.variant_title) >= 3; });
    var paid = cart.items.some(function (i) { return i.final_line_price > 0 && !isProtection(i) && !isGiftLine(i); });
    return cart.items.filter(function (i) {
      if (isProtection(i)) return !paid;
      if (!isGiftLine(i)) return false;
      if (i.product_id === CFG.trackerProductId) return !paid;
      if (CFG.maxOneVariantIds.indexOf(i.variant_id) > -1) return !subs.length;
      if (i.product_id === CFG.tongueCleanerProductId) return !cleanerSub;
      return false;
    }).map(function (i) { return i.key; });
  }

  // A free gift the customer removed stays removed for this visit (no auto re-add, no re-add on upgrade).
  function giftOff(pid) { try { return (sessionStorage.getItem('gntGiftOff') || '').split(',').indexOf(String(pid)) > -1; } catch (e) { return false; } }
  function clearGiftOff(pid) {
    try { var s = (sessionStorage.getItem('gntGiftOff') || '').split(',').filter(function (x) { return x && x !== String(pid); }); sessionStorage.setItem('gntGiftOff', s.join(',')); } catch (e) {}
  }
  function setGiftOff(pid) {
    try { var s = (sessionStorage.getItem('gntGiftOff') || '').split(',').filter(Boolean); if (s.indexOf(String(pid)) === -1) s.push(pid); sessionStorage.setItem('gntGiftOff', s.join(',')); } catch (e) {}
  }

  // Screen-only version of a quantity change / remove, including the gifts it takes with it.
  function previewChange(base, key, qty) {
    var lines = base.items.reduce(function (out, l) {
      if (l.key !== key) out.push(l);
      else if (qty > 0) {
        var f = qty / l.quantity;
        out.push(Object.assign({}, l, { quantity: qty, final_line_price: Math.round(l.final_line_price * f), original_line_price: Math.round(l.original_line_price * f) }));
      }
      return out;
    }, []);
    var gone = orphanKeys(withLines(base, lines));
    return withLines(base, lines.filter(function (l) { return gone.indexOf(l.key) === -1; }));
  }

  // A remove / quantity tap while an add or upgrade is still saving (the line on screen may be a
  // preview Shopify hasn't got yet): show it now, send it the moment Shopify has caught up.
  state.pendingChanges = [];
  function queueChange(key, qty) {
    var base = state.previewCart || state.shown || state.cart;
    var line = base && base.items.filter(function (l) { return l.key === key; })[0];
    if (!line) return;
    state.pendingChanges.push({ productId: line.product_id, variantId: line.variant_id, sub: isSub(line), qty: qty });
    state.previewCart = previewChange(base, key, qty);
    render(state.previewCart);
  }
  // Runs queued taps against Shopify's real cart. Returns true if it took over rendering.
  function flushChanges(cart) {
    if (!state.pendingChanges.length) return false;
    var changes = state.pendingChanges;
    state.pendingChanges = [];
    var updates = {};
    var after = cart.items.slice();
    changes.forEach(function (c) {
      var line = after.filter(function (l) { return l.product_id === c.productId && l.variant_id === c.variantId && isSub(l) === c.sub; })[0];
      if (!line) return;
      updates[line.key] = c.qty;
      after = after.map(function (l) { return l === line ? Object.assign({}, l, { quantity: c.qty, final_line_price: c.qty ? l.final_line_price : 0 }) : l; })
        .filter(function (l) { return l.quantity > 0; });
    });
    orphanKeys(withLines(cart, after)).forEach(function (k) { updates[k] = 0; });
    if (!Object.keys(updates).length) return false;
    state.upgrading = true; // keep refreshes off the screen until this lands
    fetchJSON('/cart/update.js', { method: 'POST', body: JSON.stringify({ updates: updates }) })
      .then(function (c) { state.cart = c; })
      .catch(function () {})
      .then(function () {
        state.upgrading = false;
        state.previewCart = null;
        if (state.pendingChanges.length && flushChanges(state.cart)) return;
        refreshSeq++;
        render(state.cart);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: state.cart }));
        scheduleRefresh();
      });
    return true;
  }

  function changeLine(key, qty, quiet) {
    if (state.upgrading || state.awaitingAdd || /^gnt-/.test(key)) return queueChange(key, qty);
    // Show the new quantity (or the removal, with any gifts it takes with it) straight away.
    if (!quiet && state.cart) {
      quiet = true;
      render(previewChange(state.cart, key, qty));
    }
    if (!quiet) setBusy(true);
    // One request for the change AND any gifts it orphans (/cart/update.js takes several line keys).
    var updates = {};
    updates[key] = qty;
    if (state.cart) {
      var after = state.cart.items.map(function (l) { return l.key === key ? Object.assign({}, l, { quantity: qty, final_line_price: qty ? l.final_line_price : 0 }) : l; })
        .filter(function (l) { return l.quantity > 0; });
      orphanKeys(withLines(state.cart, after)).forEach(function (k) { updates[k] = 0; });
    }
    return fetchJSON('/cart/update.js', { method: 'POST', body: JSON.stringify({ updates: updates }) })
      .then(function (cart) {
        // Anything still orphaned (e.g. cart changed meanwhile) goes in one more request.
        var left = orphanKeys(cart);
        if (!left.length) return cart;
        var more = {};
        left.forEach(function (k) { more[k] = 0; });
        return fetchJSON('/cart/update.js', { method: 'POST', body: JSON.stringify({ updates: more }) });
      })
      .then(function (cart) {
        refreshSeq++;
        state.cart = cart;
        render(cart);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        scheduleRefresh();
      })
      .catch(function () { return refresh(); })
      .finally(function () { if (!quiet) setBusy(false); });
  }

  // Only rewrite markup that actually changed, so background refreshes don't flash images.
  function setHTML(el, html) {
    if (el.__gntHTML === html) return;
    el.__gntHTML = html;
    el.innerHTML = html;
  }

  function withLines(cart, lines) {
    var total = lines.reduce(function (n, l) { return n + l.final_line_price; }, 0);
    return Object.assign({}, cart, {
      items: lines, total_price: total, items_subtotal_price: total,
      item_count: lines.reduce(function (n, l) { return n + l.quantity; }, 0)
    });
  }

  // Saves one upgrade. Reads Shopify's real cart first and finds the old pack there (by product,
  // variant and sub/one-off), so it works even when the tap came off an instant preview line whose
  // key Shopify has never seen. Adds the bigger pack BEFORE removing the old one, so the cart never
  // drops to "no sub" (the welcome-kit watchdog strips sub gifts when no sub is present).
  // Then runs any upgrade that was tapped meanwhile.
  function runUpgrade(job) {
    var oldLine = null;
    return fetchJSON('/cart.js')
      .then(function (base) {
        var has = function (vid) { return base.items.some(function (i) { return i.variant_id === vid; }); };
        // The pack the customer ended on (taps can be several steps ahead of Shopify): swap whichever
        // pack of this product Shopify really has, preferring the one the tapped card showed.
        var packs = base.items.filter(function (i) { return i.product_id === job.productId && isPaid(i) && !isGiftLine(i); });
        var isTarget = function (i) { return i.variant_id === job.variantId && isSub(i) === !!job.plan; };
        oldLine = packs.filter(function (i) { return i.variant_id === job.oldVariantId && isSub(i) === job.oldSub && !isTarget(i); })[0] ||
          packs.filter(function (i) { return !isTarget(i); })[0];
        if (!oldLine) return base; // already on that pack, or it was removed
        var newItem = { id: job.variantId, quantity: oldLine.quantity };
        if (job.plan) newItem.selling_plan = job.plan;
        var newItems = [newItem];
        // Gifts follow the pack: Storage Container with any welcome-kit sub, Tongue Cleaner on 3/6 months.
        var kit = job.plan && CFG.welcomeKitProductIds.indexOf(job.productId) > -1;
        job.tin = job.tin || kit;
        job.cleaner = job.cleaner || (kit && job.months >= 3);
        // Taking an offer brings its gifts back even if they were removed earlier.
        if (job.tin) clearGiftOff(8040458190936);
        if (job.cleaner) clearGiftOff(CFG.tongueCleanerProductId);
        if (job.tin && !has(CFG.maxOneVariantIds[0])) newItems.push({ id: CFG.maxOneVariantIds[0], quantity: 1, properties: { _wk_gift: 'yes' } });
        if (job.cleaner && !has(CFG.tongueCleanerVariantId)) newItems.push({ id: CFG.tongueCleanerVariantId, quantity: 1, properties: { _wk_gift: 'yes' } });
        var updates = {};
        updates[oldLine.key] = 0;
        return fetchJSON('/cart/add.js', { method: 'POST', body: JSON.stringify({ items: newItems }) })
          .then(function () { return fetchJSON('/cart/update.js', { method: 'POST', body: JSON.stringify({ updates: updates }) }); });
      })
      .then(function (cart) {
        state.cart = cart;
        var next = state.upgradeQueue;
        state.upgradeQueue = null;
        if (next) {
          // The line to replace now is whatever pack of that product is in the real cart.
          return runUpgrade(next);
        }
        state.upgrading = false;
        if (flushChanges(cart)) return;
        state.previewCart = null;
        refreshSeq++;
        render(cart);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        scheduleRefresh();
      })
      .catch(function () { state.upgrading = false; state.upgradeQueue = null; state.previewCart = null; state.pendingChanges = []; refresh(); });
  }

  // An upgrade tapped while the Add to Cart is still saving waits for it, then runs.
  function addDone() {
    state.awaitingAdd = false;
    if (state.upgradeQueue && !state.upgrading) {
      var job = state.upgradeQueue;
      state.upgradeQueue = null;
      state.upgrading = true;
      runUpgrade(job);
    }
  }

  // Instant on-screen swap for the Upgrade / Subscribe button, built from the product data we
  // already have. Shopify's real cart replaces it a moment later.
  function previewUpgrade(btn) {
    var o = state.offer;
    var cartNow = state.previewCart || state.shown || state.cart;
    if (!o || !cartNow) return;
    var line = o.line;
    var qty = line.quantity;
    var vid = parseInt(btn.getAttribute('data-variant'), 10);
    var planId = btn.getAttribute('data-plan') ? parseInt(btn.getAttribute('data-plan'), 10) : null;
    var v = o.product.variants.filter(function (x) { return x.id === vid; })[0];
    if (!v) return;
    var alloc = planId ? (v.selling_plan_allocations || []).filter(function (a) { return a.selling_plan_id === planId; })[0] : null;
    var unit = alloc ? alloc.price : v.price;
    var was = alloc ? (alloc.compare_at_price || v.price) : v.price;
    var planName = '';
    (o.product.selling_plan_groups || []).forEach(function (g) {
      g.selling_plans.forEach(function (s) { if (s.id === planId) planName = s.name; });
    });
    var preview = Object.assign({}, line, {
      key: 'gnt-upgrade-preview', variant_id: vid, variant_title: v.title,
      image: (v.featured_image && v.featured_image.src) || line.image,
      final_price: unit, final_line_price: unit * qty, original_price: was, original_line_price: was * qty,
      selling_plan_allocation: alloc ? { compare_at_price: was, selling_plan: { id: planId, name: planName } } : null
    });
    state.previewCart = withLines(cartNow, withPreviewGifts(cartNow.items.map(function (l) { return l.key === line.key ? preview : l; })));
    render(state.previewCart);
  }

  // While a protection add/remove is in flight, every render shows what the customer chose,
  // so a refresh that lands mid-request can't flip the checkbox or total back.
  function applyProtectIntent(cart) {
    if (state.protectIntent == null || !cart) return cart;
    var has = cart.items.some(isProtection);
    if (state.protectIntent === has) return cart;
    var lines = cart.items.filter(function (it) { return !isProtection(it); });
    if (state.protectIntent) {
      lines.push({ key: 'gnt-protect-preview', variant_id: CFG.protectionVariantId, product_id: 0, quantity: 1,
        final_line_price: 299, original_line_price: 299, final_price: 299, original_price: 299, requires_shipping: false });
    }
    return withLines(cart, lines);
  }
  function addItems(items) {
    setBusy(true);
    return fetchJSON('/cart/add.js', { method: 'POST', body: JSON.stringify({ items: items }) })
      .catch(function () {}).then(afterChange).finally(function () { setBusy(false); });
  }

  // Free Smart Habit Tracker on any order with a paid item (was Corner's "Free Gift" milestone).
  // Price is zeroed at checkout by the GNT welcome-kit discount function.
  // Shipping Protection is pre-selected (Kevin, Oct 2026). Unticking it is remembered for the
  // session so we never sneak it back in after the customer has said no.
  function protectOptedOut() { try { return sessionStorage.getItem('gntProtectOff') === '1'; } catch (e) { return false; } }
  function setProtectOptOut(off) { try { off ? sessionStorage.setItem('gntProtectOff', '1') : sessionStorage.removeItem('gntProtectOff'); } catch (e) {} }

  // Keeps the automatic extras in step with the cart:
  //  - free Smart Habit Tracker on any order with a paid item (zeroed by the welcome-kit function)
  //  - Shipping Protection pre-selected unless opted out; removed again when nothing paid is left
  function syncTrackerGift(cart) {
    if (state.giftSyncing) return Promise.resolve(false);
    var paid = cart.items.filter(function (it) { return isPaid(it) && it.product_id !== CFG.trackerProductId; });
    var trackers = cart.items.filter(function (it) { return it.product_id === CFG.trackerProductId; });
    var giftTrackers = trackers.filter(function (it) { return hasProp(it, '_gnt_gift') || it.final_line_price === 0; });
    var prot = cart.items.filter(isProtection)[0];
    var adds = [];
    var removeKeys = [];
    if (paid.length && !trackers.length && !giftOff(CFG.trackerProductId)) adds.push({ id: CFG.trackerVariantId, quantity: 1, properties: { _gnt_gift: 'tracker' } });
    // Hands off protection while the customer's own tick/untick is still being saved.
    var protSettling = state.protectIntent != null || protBusy;
    if (protSettling) prot = null;
    if (!protSettling && paid.length && !prot && !protectOptedOut()) adds.push({ id: CFG.protectionVariantId, quantity: 1 });
    if (!paid.length && giftTrackers.length) removeKeys.push(giftTrackers[0].key);
    if (prot && (!paid.length || protectOptedOut())) removeKeys.push(prot.key);
    // Never more than one: Shipping Protection qty 1, one gifted tracker (bought trackers untouched).
    var changes = [];
    if (prot && removeKeys.indexOf(prot.key) === -1 && prot.quantity > 1) changes.push({ id: prot.key, quantity: 1 });
    giftTrackers.slice(1).forEach(function (it) { if (hasProp(it, '_gnt_gift')) removeKeys.push(it.key); });
    if (giftTrackers[0] && giftTrackers[0].quantity > 1 && hasProp(giftTrackers[0], '_gnt_gift')) changes.push({ id: giftTrackers[0].key, quantity: 1 });
    if (!adds.length && !removeKeys.length && !changes.length) return Promise.resolve(false);
    var post = function (url, body) {
      return rawFetch(url, {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      });
    };
    var job = adds.length ? post('/cart/add.js', { items: adds }) : Promise.resolve();
    removeKeys.forEach(function (key) { job = job.then(function () { return post('/cart/change.js', { id: key, quantity: 0 }); }); });
    changes.forEach(function (c) { job = job.then(function () { return post('/cart/change.js', c); }); });
    state.giftSyncing = true;
    return job.catch(function () {}).then(function () { state.giftSyncing = false; return true; });
  }

  // ---------- render ----------
  // Overlapping refreshes (our own + welcome-kit's cart:refresh events) only render the latest one.
  // Render first (fast), then fix up the tracker gift in the background and refresh once more.
  var refreshSeq = 0;
  var giftAttempts = 0;
  function refresh() {
    var seq = ++refreshSeq;
    return fetchJSON('/cart.js').then(function (cart) {
      if (seq !== refreshSeq) return;
      // Mid-upgrade / mid-add the screen shows the customer's choice; the real cart renders when done.
      if (state.upgrading || state.awaitingAdd) return;
      state.cart = cart;
      if (flushChanges(cart)) return;
      render(cart);
      if (giftAttempts >= 3) return;
      return syncTrackerGift(cart).then(function (changed) {
        if (!changed) { giftAttempts = 0; return; }
        giftAttempts++;
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        return refresh();
      });
    }).catch(function () {});
  }

  function shippingCents(cart) {
    // General-profile items pay $7.95 unless the whole cart reaches $60. Subs (Seal profile),
    // the $0 gift-profile products and Shipping Protection (no shipping) never trigger it.
    var needsPaidShipping = cart.items.some(function (it) {
      return it.requires_shipping && it.final_line_price > 0 && !isSub(it) &&
        CFG.freeShippingProductIds.indexOf(it.product_id) === -1;
    });
    if (!needsPaidShipping) return 0;
    return cart.items_subtotal_price >= CFG.freeShippingThreshold ? 0 : CFG.standardShipping;
  }

  function wasPrice(item) {
    // Compared with the pack's compare-at price, which is the 1 month price x the months (what
    // buying a month at a time really costs), for subs AND one-offs; gifts at their normal price.
    // Matches the product page's SAVE (gnt-save-total.js). Kevin, 11 Oct 2026.
    var unit = item.original_price;
    if (item.selling_plan_allocation && item.selling_plan_allocation.compare_at_price) {
      unit = Math.max(unit, item.selling_plan_allocation.compare_at_price);
    }
    var p = productData[item.handle];
    var v = p && p.variants.filter(function (x) { return x.id === item.variant_id; })[0];
    if (v && v.compare_at_price) unit = Math.max(unit, v.compare_at_price);
    return unit * item.quantity;
  }

  function planNote(item) {
    var name = item.selling_plan_allocation.selling_plan.name || '';
    var n = monthsOf(name);
    var every = /monthly/i.test(name) || n === 1 ? 'every month' : (n ? 'every ' + n + ' months' : 'on repeat');
    return 'Renews ' + (every === 'every month' ? 'monthly' : every) + ' &middot; cancel anytime';
  }

  // Draws the cart straight away; only the upgrade card waits on product data.
  function render(cart) {
    cart = applyProtectIntent(cart);
    state.shown = cart;
    var seq = refreshSeq;
    state.loaded = true;
    if (!state.awaitingAdd) setPending(false);
    (function () {
      var visibleCount = cart.items.reduce(function (n, it) { return isProtection(it) ? n : n + it.quantity; }, 0);
      els.count.textContent = visibleCount ? '(' + visibleCount + ' item' + (visibleCount === 1 ? '' : 's') + ')' : '';
      updateHeaderCount(cart.item_count);

      var hasItems = cart.items.some(function (it) { return !isProtection(it); });
      els.empty.hidden = hasItems;
      els.footer.hidden = !hasItems;
      els.sumwrap.hidden = !hasItems;
      if (!hasItems) { try { sessionStorage.removeItem('gntGiftOff'); } catch (e) {} } // empty cart = fresh start
      els.items.hidden = !hasItems;

      // Items: real products first, gifts after, protection hidden (it has its own checkbox)
      var lines = cart.items.filter(function (it) { return !isProtection(it); });
      lines.sort(function (a, b) { return (isGift(a) ? 1 : 0) - (isGift(b) ? 1 : 0); });
      var wasTotal = 0;
      setHTML(els.items, lines.map(function (it) {
        var was = wasPrice(it);
        wasTotal += was;
        return itemHTML(it, was);
      }).join(''));
      cart.items.filter(isProtection).forEach(function (it) { wasTotal += it.original_line_price; });

      // Strip + progress
      var ship = shippingCents(cart);
      var anySub = cart.items.some(isSub);
      if (!hasItems) {
        els.strip.hidden = true;
      } else {
        els.strip.hidden = false;
        if (ship === 0) {
          els.stripText.innerHTML = 'Congrats! You’ve unlocked <strong>free shipping!</strong>';
          els.progress.hidden = true;
        } else {
          var left = CFG.freeShippingThreshold - cart.items_subtotal_price;
          els.stripText.innerHTML = 'You’re <strong>' + money(left) + '</strong> away from <strong>free shipping</strong>';
          els.progress.hidden = false;
          els.progressFill.style.width = Math.min(100, Math.round(cart.items_subtotal_price / CFG.freeShippingThreshold * 100)) + '%';
        }
      }

      // Summary. Totals come from the lines, never cart.total_price: /cart/change.js responses
      // fold an estimated shipping charge into total_price, which would double-count shipping.
      var orderDiscounts = (cart.cart_level_discount_applications || []).reduce(function (n, d) { return n + (d.total_allocated_amount || 0); }, 0);
      var itemsTotal = cart.items.reduce(function (n, it) { return n + it.final_line_price; }, 0) - orderDiscounts;
      var discount = Math.max(0, wasTotal - itemsTotal);
      els.subtotal.innerHTML = discount > 0 ? '<s>' + money(wasTotal) + '</s>' : money(itemsTotal);
      els.discountRow.hidden = discount === 0;
      els.discount.textContent = '-' + money(discount);
      // Shipping only appears when it's free; a paid rate is left for checkout and never added
      // to Total Today (Kevin, Oct 2026).
      var shipFree = ship === 0;
      els.shipping.parentElement.hidden = !shipFree;
      els.shipping.textContent = 'Free';
      els.shipping.classList.add('gnt-cart__green');
      els.total.textContent = money(itemsTotal);
      els.saveRow.hidden = discount === 0;
      // Same basis as the product page's SAVE: real savings plus free shipping at $7.95, nearest dollar.
      var saveTotal = discount + (shipFree && hasItems ? CFG.standardShipping : 0);
      els.save.textContent = 'You save $' + Math.round(saveTotal / 100) + (shipFree ? ' incl. free shipping' : '');

      // Shipping Protection
      var prot = cart.items.filter(isProtection)[0];
      els.protectInput.checked = !!prot;
      els.protect.hidden = !hasItems;
      renderRecs(cart);
    })();

    // Compare-at prices come from product data; if any weren't loaded yet, draw once more when they are.
    var missing = cart.items.some(function (it) { return it.handle && !productData[it.handle]; });
    return Promise.all(cart.items.map(function (it) { return getProduct(it.handle); })).then(function (products) {
      if (seq !== refreshSeq) return;
      if (missing && cart.items.every(function (it) { return !it.handle || productData[it.handle]; })) return render(cart);
      var byHandle = {};
      products.forEach(function (p) { if (p) byHandle[p.handle] = p; });
      renderUpgrade(cart, byHandle);
    });
  }

  function itemHTML(it, was) {
    var gift = isGift(it);
    var sub = isSub(it);
    var pct = was > it.final_line_price && !gift ? Math.round((1 - it.final_line_price / was) * 100) : 0;
    var maxOne = CFG.maxOneVariantIds.indexOf(it.variant_id) > -1;
    var variant = it.variant_title && it.variant_title !== 'Default Title' ? '<p class="gnt-cart__item-variant">' + esc(it.variant_title) + '</p>' : '';
    // Gifts need no note: the GIFT pill says it, and the extra row only adds height.
    var note = sub ? '<p class="gnt-cart__item-note">' + planNote(it) + '</p>' : '';
    var prices = gift
      ? '<span class="gnt-cart__price">FREE</span><s class="gnt-cart__was">' + money(it.original_line_price) + '</s><span class="gnt-cart__pill gnt-cart__pill--gift">GIFT</span>'
      : '<span class="gnt-cart__price">' + money(it.final_line_price) + '</span>' +
        (was > it.final_line_price ? '<s class="gnt-cart__was">' + money(was) + '</s>' : '') +
        (pct >= 5 ? '<span class="gnt-cart__pill">' + pct + '% OFF</span>' : '');
    var trash = '<button type="button" class="gnt-cart__remove" data-gnt-remove="' + esc(it.key) + '"' + (gift ? ' data-gnt-gift="' + it.product_id + '"' : '') +
        ' aria-label="Remove ' + esc(it.product_title) + '">' +
        '<svg viewBox="0 0 24 24" width="15" height="15" aria-hidden="true"><path d="M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/></svg></button>';
    // Gifts: remove only (no quantity). Paid items: remove + quantity.
    var side = gift ? trash : trash +
      '<div class="gnt-cart__qty">' +
        '<button type="button" data-gnt-qty="' + esc(it.key) + '" data-q="' + (it.quantity - 1) + '" aria-label="Decrease quantity">&minus;</button>' +
        '<span>' + it.quantity + '</span>' +
        '<button type="button" data-gnt-qty="' + esc(it.key) + '" data-q="' + (it.quantity + 1) + '" aria-label="Increase quantity"' + (maxOne ? ' disabled' : '') + '>+</button>' +
      '</div>';
    return '<li class="gnt-cart__item">' +
      '<img class="gnt-cart__item-img" src="' + esc(img(it.image, 160)) + '" alt="" loading="lazy">' +
      '<div><p class="gnt-cart__item-title"><a href="' + esc(it.url) + '">' + esc(it.product_title) + '</a></p>' + variant +
        '<div class="gnt-cart__prices">' + prices + '</div></div>' +
      '<div class="gnt-cart__item-side">' + side + '</div>' +
      note +
    '</li>';
  }

  // Bigger-pack upgrade: first paid line (sub or one-off) on a 1- or 3-month variant with a larger tier.
  // Subs move to the bigger variant's own selling plan (each tier variant carries one plan).
  // One-off lines that can be subscribed get "Subscribe & save" instead (same pack, sub price,
  // plus the welcome-kit gifts: Storage Container always, Tongue Cleaner on 3/6 months).
  function renderUpgrade(cart, byHandle) {
    var offer = null;
    var hasCleaner = cart.items.some(function (it) { return it.product_id === CFG.tongueCleanerProductId; });
    var hasTin = cart.items.some(function (it) { return CFG.maxOneVariantIds.indexOf(it.variant_id) > -1; });
    cart.items.some(function (it) {
      if (!isPaid(it) || isGift(it) || isSub(it)) return false;
      var product = byHandle[it.handle];
      if (!product) return false;
      var v = product.variants.filter(function (x) { return x.id === it.variant_id; })[0];
      var alloc = v && (v.selling_plan_allocations || [])[0];
      if (!alloc || alloc.price * it.quantity >= it.final_line_price) return false;
      var m = monthsOf(it.variant_title) || 1;
      var kit = CFG.welcomeKitProductIds.indexOf(it.product_id) > -1;
      offer = {
        kind: 'subscribe', line: it, product: product, plan: alloc.selling_plan_id,
        saving: it.final_line_price - alloc.price * it.quantity,
        // Offers always include every gift they promise, even one removed earlier.
        tin: kit && !hasTin, cleaner: kit && m >= 3 && !hasCleaner
      };
      return true;
    });
    if (offer) { state.offer = offer; renderSubscribeOffer(offer); return markUpgradeBusy(); }

    cart.items.some(function (it) {
      if (!isPaid(it) || isGift(it)) return false;
      var product = byHandle[it.handle];
      var m = monthsOf(it.variant_title);
      if (!product || !m) return false;
      var sub = isSub(it);
      var tiers = product.variants
        .map(function (v) {
          var alloc = sub ? (v.selling_plan_allocations || [])[0] : null;
          return { v: v, m: monthsOf(v.title), plan: alloc ? alloc.selling_plan_id : null, price: alloc ? alloc.price : v.price };
        })
        .filter(function (t) { return t.m && t.m > m && t.v.available && (!sub || t.plan); })
        .sort(function (a, b) { return a.m - b.m; });
      if (!tiers.length) return false;
      var next = tiers[0];
      var extra = next.price * it.quantity - it.final_line_price;
      var saving = (it.final_line_price / it.quantity) * (next.m / m) * it.quantity - next.price * it.quantity;
      if (extra <= 0) return false;
      var cleaner = sub && next.m >= 3 && !hasCleaner && CFG.welcomeKitProductIds.indexOf(it.product_id) > -1;
      offer = { line: it, next: next, extra: extra, saving: saving, product: product, sub: sub, cleaner: cleaner };
      return true;
    });
    state.offer = offer;
    if (!offer) { els.upgrade.hidden = true; setHTML(els.upgrade, ''); return; }
    var pic = (offer.next.v.featured_image && offer.next.v.featured_image.src) || offer.product.featured_image || offer.line.image;
    var perks = [];
    if (offer.saving >= 100) perks.push('Save ' + money(Math.round(offer.saving / 100) * 100));
    if (offer.cleaner) perks.push(giftsLine(1));
    var tierLabel = offer.next.m + ' months';
    els.upgrade.hidden = false;
    setHTML(els.upgrade,
      '<div class="gnt-cart__upgrade-card">' +
        '<img src="' + esc(img(pic, 120)) + '" alt="" loading="lazy">' +
        '<div><p class="gnt-cart__upgrade-title">Upgrade to ' + tierLabel + '</p>' +
          perks.map(function (p) { return '<p class="gnt-cart__upgrade-sub">' + p + '</p>'; }).join('') + '</div>' +
        '<button type="button" class="gnt-cart__upgrade-btn" data-gnt-upgrade data-key="' + esc(offer.line.key) + '" data-variant="' + offer.next.v.id + '"' +
          ' data-qty="' + offer.line.quantity + '"' + (offer.next.plan ? ' data-plan="' + offer.next.plan + '"' : '') + (offer.cleaner ? ' data-cleaner="1"' : '') +
          '>Upgrade &rarr; +' + money(offer.extra) + '</button>' +
      '</div>');
    markUpgradeBusy();
  }

  // While an upgrade is still saving, the NEXT card shows straight away with its button greyed out,
  // so it never disappears and pops back. It unlocks as soon as Shopify confirms the first upgrade.
  function markUpgradeBusy() {
    // Buttons stay live now: taps during a save are queued (see runUpgrade).
    var b = els.upgrade.querySelector('[data-gnt-upgrade]');
    if (b) b.disabled = false;
  }

  function giftsLine(n) { return n ? '+ ' + n + ' FREE gift' + (n > 1 ? 's' : '') : ''; }

  function renderSubscribeOffer(offer) {
    var gifts = (offer.tin ? 1 : 0) + (offer.cleaner ? 1 : 0);
    els.upgrade.hidden = false;
    setHTML(els.upgrade,
      '<div class="gnt-cart__upgrade-card">' +
        '<img src="' + esc(img(offer.line.image, 120)) + '" alt="" loading="lazy">' +
        '<div><p class="gnt-cart__upgrade-title">Subscribe &amp; save ' + Math.round(offer.saving / offer.line.final_line_price * 100) + '%</p>' +
          (gifts ? '<p class="gnt-cart__upgrade-sub">' + giftsLine(gifts) + '</p>' : '') +
          '<p class="gnt-cart__upgrade-sub">+ FREE Shipping</p></div>' +
        '<button type="button" class="gnt-cart__upgrade-btn" data-gnt-upgrade data-key="' + esc(offer.line.key) + '" data-variant="' + offer.line.variant_id + '"' +
          ' data-qty="' + offer.line.quantity + '" data-plan="' + offer.plan + '"' + (offer.tin ? ' data-tin="1"' : '') + (offer.cleaner ? ' data-cleaner="1"' : '') +
          '>Subscribe &rarr;</button>' +
      '</div>');
  }

  // "Customers also add" via Shopify product recommendations.
  function renderRecs(cart) {
    var anchor = cart.items.filter(function (it) { return isPaid(it) && !isGift(it); })[0];
    if (!anchor) { els.recs.hidden = true; recsKey = ''; return; }
    var inCart = cart.items.map(function (it) { return it.product_id; });
    var key = anchor.product_id + ':' + cart.items.filter(function (it) { return isPaid(it) && !isGift(it); })
      .map(function (it) { return it.product_id; }).sort().join(',');
    if (key === recsKey) return;
    recsKey = key;
    getRecs(anchor.product_id)
      .then(function (data) {
        var list = (data.products || []).filter(function (p) {
          return p.available && inCart.indexOf(p.id) === -1 && CFG.giftProductIds.indexOf(p.id) === -1 &&
            p.variants && p.variants.some(function (v) { return v.available && v.id !== CFG.protectionVariantId && v.price > 0; });
        }).slice(0, 6);
        if (!list.length) { els.recs.hidden = true; return; }
        els.recs.hidden = false;
        setHTML(els.recsTrack, list.map(function (p) {
          var v = p.variants.filter(function (x) { return x.available; })[0];
          var pic = p.featured_image || (p.images && p.images[0]);
          return '<div class="gnt-cart__rec">' +
            '<a href="' + esc(p.url) + '"><img src="' + esc(img(pic, 320)) + '" alt="' + esc(p.title) + '" loading="lazy"></a>' +
            '<p class="gnt-cart__rec-title">' + esc(p.title) + '</p>' +
            '<div class="gnt-cart__rec-row"><span><span class="gnt-cart__price">' + money(v.price) + '</span>' +
              (v.compare_at_price > v.price ? ' <s class="gnt-cart__was">' + money(v.compare_at_price) + '</s>' : '') + '</span>' +
              '<button type="button" class="gnt-cart__rec-add" data-gnt-add="' + v.id + '">ADD</button></div>' +
          '</div>';
        }).join(''));
      }).catch(function () { els.recs.hidden = true; });
  }

  function updateHeaderCount(n) {
    try {
      if (window.Alpine && Alpine.store && Alpine.store('cart_count')) Alpine.store('cart_count').count = n;
    } catch (e) {}
  }

  // ---------- events ----------
  root.addEventListener('click', function (e) {
    var t = e.target.closest('button, [data-gnt-cart-close]');
    if (!t || state.busy) return;
    if (t.hasAttribute('data-gnt-cart-close')) return close();
    if (t.hasAttribute('data-gnt-remove')) {
      if (t.hasAttribute('data-gnt-gift')) setGiftOff(t.getAttribute('data-gnt-gift'));
      return changeLine(t.getAttribute('data-gnt-remove'), 0);
    }
    if (t.hasAttribute('data-gnt-qty')) return changeLine(t.getAttribute('data-gnt-qty'), Math.max(0, parseInt(t.getAttribute('data-q'), 10)));
    if (t.hasAttribute('data-gnt-add')) return addItems([{ id: parseInt(t.getAttribute('data-gnt-add'), 10), quantity: 1 }]);
    if (t.hasAttribute('data-gnt-upgrade')) {
      // Every tap shows instantly. If an earlier upgrade is still saving, this one is queued
      // (latest tap wins) and saved straight after, so the button never has to wait.
      var job = {
        productId: state.offer && state.offer.line.product_id,
        oldVariantId: state.offer && state.offer.line.variant_id,
        oldSub: !!(state.offer && isSub(state.offer.line)),
        variantId: parseInt(t.getAttribute('data-variant'), 10),
        plan: t.getAttribute('data-plan') ? parseInt(t.getAttribute('data-plan'), 10) : null,
        qty: parseInt(t.getAttribute('data-qty'), 10) || 1,
        months: state.offer && (state.offer.next ? state.offer.next.m : monthsOf(state.offer.line.variant_title)),
        tin: !!t.getAttribute('data-tin'),
        cleaner: !!t.getAttribute('data-cleaner')
      };
      previewUpgrade(t);
      if (state.upgrading || state.awaitingAdd) { state.upgradeQueue = job; return; }
      state.upgrading = true;
      return runUpgrade(job);
    }
    if (t.hasAttribute('data-gnt-recs-prev') || t.hasAttribute('data-gnt-recs-next')) {
      var dir = t.hasAttribute('data-gnt-recs-next') ? 1 : -1;
      els.recsTrack.scrollBy({ left: dir * 168, behavior: 'smooth' });
    }
  });

  // Shipping Protection: the box always shows the LAST tap. One request at a time; when it
  // returns we compare Shopify's real cart with the last tap and send another if they differ.
  // Fast off/on/off taps therefore always settle on what the customer chose last.
  var protBusy = false;
  function settleProtection(cart) {
    refreshSeq++;
    state.cart = cart;
    reconcileProtection();
  }
  function reconcileProtection() {
    if (protBusy || state.protectIntent == null || !state.cart) return;
    var prot = state.cart.items.filter(isProtection)[0];
    var want = state.protectIntent;
    if (want && !prot) {
      protBusy = true;
      fetchJSON('/cart/add.js', { method: 'POST', body: JSON.stringify({ items: [{ id: CFG.protectionVariantId, quantity: 1 }] }) })
        .then(function () { return fetchJSON('/cart.js'); })
        .then(function (cart) { protBusy = false; settleProtection(cart); })
        .catch(function () { protBusy = false; state.protectIntent = null; refresh(); });
    } else if (!want && prot) {
      protBusy = true;
      fetchJSON('/cart/change.js', { method: 'POST', body: JSON.stringify({ id: prot.key, quantity: 0 }) })
        .then(function (cart) { protBusy = false; settleProtection(cart); })
        .catch(function () { protBusy = false; state.protectIntent = null; refresh(); });
    } else {
      // Shopify now matches the last tap.
      state.protectIntent = null;
      render(state.cart);
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: state.cart }));
    }
  }
  els.protectInput.addEventListener('change', function () {
    if (!state.cart) return;
    var on = els.protectInput.checked;
    setProtectOptOut(!on);
    state.protectIntent = on;
    render(state.cart);
    reconcileProtection();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.classList.contains('is-open')) close();
  });

  // Take over the header cart button (capture phase, ahead of the theme's Alpine handler).
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('#CartButton, [data-cart-drawer-trigger], a[href="/cart"].js-gnt-cart-link');
    if (!trigger) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    open();
  }, true);

  // Open instantly on any Add to Cart tap. Registered on window (capture) because
  // gnt-welcome-kit-card.js stops propagation at document level for the same click.
  window.addEventListener('click', function (e) {
    var atc = e.target.closest('form[action*="/cart/add"] [type="submit"], form[action*="/cart/add"] button[name="add"], gp-product-button');
    if (!atc || atc.disabled || atc.closest('#GntCart')) return;
    openPending();
    try { previewAdd(atc); } catch (err) {} // falls back to the spinner if the page data isn't ready
  }, true);

  // Speed: ride the free tracker along on the customer's own /cart/add request (JSON adds),
  // instead of a second add afterwards. Our own calls use rawFetch so they skip this wrapper.
  var pageFetch = window.fetch;
  window.fetch = function (input, init) {
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (state.cart && /\/cart\/add(\.js)?(\?|$)/.test(url) && init && typeof init.body === 'string') {
        var body = JSON.parse(init.body);
        var items = Array.isArray(body.items) ? body.items : null;
        var has = function (vid) {
          return state.cart.items.some(function (it) { return it.variant_id === vid; }) ||
            items.some(function (i) { return parseInt(i.id, 10) === vid; });
        };
        if (items && items.length) {
          var before = items.length;
          if (!has(CFG.trackerVariantId) && !giftOff(CFG.trackerProductId)) items.push({ id: CFG.trackerVariantId, quantity: 1, properties: { _gnt_gift: 'tracker' } });
          if (!has(CFG.protectionVariantId) && !protectOptedOut()) items.push({ id: CFG.protectionVariantId, quantity: 1 });
          if (items.length !== before) init = Object.assign({}, init, { body: JSON.stringify(body) });
        }
      }
    } catch (e) {}
    var req = pageFetch.call(this, input, init);
    if (/\/cart\/add(\.js)?(\?|$)/.test(url || '')) {
      req.then(function (res) {
        if (!res || !res.ok) return;
        res.clone().json().then(optimisticAdd).catch(function () {});
      }).catch(function () {});
    }
    return req;
  };

  // Draw straight from the /cart/add response (like Corner does), then confirm with /cart.js.
  function optimisticAdd(data) {
    var added = (data && (data.items || (data.id ? [data] : []))) || [];
    if (!added.length || !state.cart) return;
    var lines = state.cart.items.slice();
    added.forEach(function (a) {
      if (a.product_id === CFG.trackerProductId && hasProp(a, '_gnt_gift')) {
        a = Object.assign({}, a, { final_line_price: 0, final_price: 0 });
      }
      var i = lines.findIndex(function (l) { return l.key === a.key; });
      if (i > -1) lines[i] = a; else lines.unshift(a);
    });
    var sum = function (f) { return lines.reduce(function (n, l) { return n + (l[f] || 0); }, 0); };
    var cart = Object.assign({}, state.cart, {
      items: lines,
      item_count: lines.reduce(function (n, l) { return n + l.quantity; }, 0),
      items_subtotal_price: sum('final_line_price'),
      total_price: sum('final_line_price')
    });
    state.cart = cart;
    var queued = !!state.upgradeQueue || state.upgrading;
    addDone();
    if (queued) return; // the upgrade preview stays on screen; runUpgrade renders the result
    if (flushChanges(cart)) return;
    if (!root.classList.contains('is-open')) open(); else render(cart);
    scheduleRefresh();
  }

  // Several events fire per add; collapse them into one cart read.
  var refreshTimer = null;
  function scheduleRefresh() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refresh, 40);
  }

  // shapes:modalcart:afteradditem is dispatched on body with bubbles, so document catches both.
  ['cart:item-added', 'shapes:modalcart:afteradditem'].forEach(function (evt) {
    document.addEventListener(evt, function () {
      addDone();
      if (!root.classList.contains('is-open')) open(); else scheduleRefresh();
    });
  });
  document.addEventListener('cart:refresh', scheduleRefresh);

  // GemPages landing-page buttons ("open-cart-drawer"): GemPages calls GPF.openCartDrawer if it
  // exists, otherwise it sends the customer to /cart. Hand it our drawer instead.
  // Preload while browsing: on a product page, fetch that product's data and its recommendations
  // when the browser is idle, so the upgrade card and "Customers also add" are ready the moment
  // the drawer opens instead of loading after the add.
  var idle = window.requestIdleCallback || function (fn) { return setTimeout(fn, 1500); };
  var pdp = /^\/products\/([^/?#]+)/.exec(location.pathname);
  if (pdp) idle(function () { getProduct(pdp[1]).then(function (p) { if (p) getRecs(p.id); }); });
  idle(function () { (CFG.giftHandles || []).forEach(getProduct); }); // gift lines for instant previews

  window.GPF = window.GPF || {};
  window.GPF.openCartDrawer = function () { addDone(); open(); };
  window.addEventListener('gp:add-to-cart-success', function () { addDone(); scheduleRefresh(); });

  // ---------- mobile sticky Add to Cart (product pages) ----------
  // Visible whenever the page's own Add to Cart is off screen. Tapping it presses the real button,
  // so the chosen pack, sub/one-off choice and welcome-kit gifts all behave exactly as normal.
  (function () {
    var bar = document.getElementById('GntStickyAtc');
    if (!bar) return;
    var real = [].slice.call(document.querySelectorAll('form[action*="/cart/add"] .add-to-cart-btn, form[action*="/cart/add"] [type="submit"]'))
      .filter(function (b) { return !b.closest('#GntCart') && b.offsetParent !== null; })[0];
    if (!real || !('IntersectionObserver' in window)) { bar.remove(); return; }
    var btn = bar.querySelector('button');
    var syncState = function () {
      btn.disabled = real.disabled;
      btn.textContent = real.disabled ? 'Sold out' : 'Add to Cart';
    };
    btn.addEventListener('click', function () { if (!real.disabled) real.click(); });
    new MutationObserver(syncState).observe(real, { attributes: true, attributeFilter: ['disabled'] });
    syncState();
    new IntersectionObserver(function (entries) {
      var show = !entries[0].isIntersecting;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      btn.tabIndex = show ? 0 : -1;
      document.body.classList.toggle('gnt-sticky-on', show);
    }).observe(real);
  })();

  window.GntCartDrawer = { open: open, close: close, refresh: refresh };
  refresh();
})();
